import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Trustpilot from '../../services/Trustpilot.js';

window.Swiper = Swiper;

export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('TrustpilotSliderComponent', () => ({
        swiper: null,
        init() {
          const maxBullets = 3;
          const isDesktop = window.innerWidth > 1024;

          this.swiper = new Swiper('#trustpilot-slider-container', {
            slidesPerView: 1.5,
            spaceBetween: 24,
            centeredSlides: true,
            loop: !isDesktop,
            autoplay: {
              delay: 3000,
              disableOnInteraction: false,
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
              renderBullet: function (index, className) {
                if (index < maxBullets) {
                  return `<span class="${className}"></span>`;
                }
                return '';
              },
            },
            navigation: {
              nextEl: '.custom-swiper-button-next',
              prevEl: '.custom-swiper-button-prev',
            },
            on: {
              slideChange: function () {
                const activeIndex = this.realIndex % maxBullets;

                document
                  .querySelectorAll('.swiper-pagination-bullet')
                  .forEach((bullet) => {
                    bullet.classList.remove('swiper-pagination-bullet-active');
                  });

                const activeBullet = document.querySelectorAll(
                  '.swiper-pagination-bullet',
                )[activeIndex];
                if (activeBullet) {
                  activeBullet.classList.add('swiper-pagination-bullet-active');
                }
              },
            },
          });
        },
      }));

      instance.data(
        'TrustpilotCardsSliderComponent',
        (numberOfReviews = 10, tagGroup = '') => {
          return {
            activeIndex: 0,
            slides: [],
            loading: true,
            async init() {
              try {
                const response = await Trustpilot.getReviews(
                  numberOfReviews,
                  tagGroup,
                );

                if (response.status !== 200) {
                  throw new Error('Failed to fetch reviews');
                }

                const data = await response.data;

                this.slides = data.data || [];
                this.loading = false;
              } catch (error) {
                console.error('Error fetching reviews:', error);
                this.slides = [
                  {
                    id: '624f6c562b3c3c43cfcc4398',
                    consumer: {
                      displayName: 'Edward Labra',
                    },
                    stars: 5,
                    text: 'Very easy non confusing step by step guide on how to form your llc.',
                  },
                  {
                    id: '624f60f3c7628b203ba611ee',
                    consumer: {
                      displayName: 'Gordon Steimle',
                    },
                    stars: 5,
                    text: 'Very easy to set up a business LLC. Web site is very easy to navigate!',
                  },
                  {
                    id: '624f5ea82b3c3c43cfcc3d55',
                    consumer: {
                      displayName: 'Carlos Campos',
                    },
                    stars: 4,
                    text: 'Convenient and Easy to use...Alil less nickel and diming would be nice',
                  },
                ];
                this.loading = false;
              }
            },
            next() {
              this.activeIndex = (this.activeIndex + 1) % this.slides.length;
            },
            prev() {
              this.activeIndex =
                (this.activeIndex - 1 + this.slides.length) %
                this.slides.length;
            },
          };
        },
      );
    });
  },
};
